import {
  AccountPayable,
  InstallmentRenegotiateFormValues,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { Col, Form, FormInstance, Row } from 'antd';
import React from 'react';
import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';

interface Props {
  form: FormInstance<InstallmentRenegotiateFormValues>;
  accountPayable?: AccountPayable;
}

const RenegotiateInstallmentForm: React.FC<Props> = ({ form }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form form={form}>
      <Row gutter={[24, 24]}>
        <Col span={24} lg={5}>
          <FloatingFormItem
            name={'valueTotal'}
            label={'Valor'}
            rules={[defaultEmptyFieldError]}
          >
            <InputDecimal disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={7}>
          <FloatingFormItem
            name={'fromThatDate'}
            label={'A partir de:'}
            rules={[defaultEmptyFieldError]}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={6}>
          <FloatingFormItem
            name="quantityInstallments"
            label="Parcelas"
            rules={[defaultEmptyFieldError]}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={6}>
          <FloatingFormItem
            name="intervalDays"
            label="Intervalo (dias)"
            rules={[defaultEmptyFieldError]}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default RenegotiateInstallmentForm;
